<template>
    <!-- 基本模板 -->
    <div class="container" >
        <PageHeader style="margin:10px 0 0 0;"/>
        <div class="content page_main_content">
            <div class="content">
                <div class="page_searcher">
                    <Searcher :items="config.searchers" @search="getData" ref="searcher"/>
                </div>
                <div>
                    <div class="page_block" v-for="(mod, index) in datas" :key="`mod_${index}`" :style="mod.module_style">
                        <a-row v-if="index===0">
                            <a-col :span="12">
                                <div class="page_block_content">
                                    <div v-html="infos[0][0]"></div>
                                    <a-divider />
                                    <div style="text-align:right">
                                        <a-button-group style="margin:0 0 20px 10px" >
                                            <a-button @click="lockHeader(0,1)" :type="locks.indexOf('0_1')>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf('0_1')>=0?'取消固定':'固定表头'}}</a-button>
                                            <a-button @click="exportToExcel(0,1)"><a-icon type="download"/>下载数据</a-button>
                                            <a-button @click="copy(0, 1)" id="copy-btn"><a-icon type="copy"/>复制数据</a-button>
                                        </a-button-group>
                                    </div>
                                    <DataTable  :small="true" :liucun="modules[0].liucun" :fields="modules[0].fields" :theads="modules[0].theads" :datas="datas[0][0]" ref="datatable_0_1" :paging="false" :marks="marks" :table="config.table" :color="config.color" :ctrl="config.ctrl" />
                                </div>
                            </a-col>
                            <a-col :span="12">
                                <div class="page_block_content">
                                    <div v-html="infos[0][1]"></div>
                                    <a-divider />
                                    <div style="text-align:right">
                                        <a-button-group style="margin:0 0 20px 10px" >
                                            <a-button @click="lockHeader(0,2)" :type="locks.indexOf('0_2')>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf('0_2')>=0?'取消固定':'固定表头'}}</a-button>
                                            <a-button @click="exportToExcel(0,2)"><a-icon type="download"/>下载数据</a-button>
                                            <a-button @click="copy(0, 2)" id="copy-btn"><a-icon type="copy"/>复制数据</a-button>
                                        </a-button-group>
                                    </div>
                                    <DataTable  :small="true" :liucun="modules[0].liucun" :fields="modules[0].fields" :theads="modules[0].theads" :datas="datas[0][1]" ref="datatable_0_2" :paging="false" :marks="marks" :table="config.table" :color="config.color" :ctrl="config.ctrl" />
                                </div>
                            </a-col>
                        </a-row>
                        <div class="page_block_content" v-else>
                            <h3 v-html="`${mod.name?mod.name:mod.title?mod.title:''}${mod.desc?`<div style='color: #999; font-size: 13px; font-weight: normal; margin-left: 30px; display:inline-block'>${mod.desc}</div>`:''}`"></h3>
                            
                            <h3>
                                <a-button-group style="float:right; margin:0 0 10px 10px" >
                                    <a-button @click="lockHeader(index)" :type="locks.indexOf(index)>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf(index)>=0?$t("common.cancelFix"):$t("common.fixHead")}}</a-button>
                                    <a-button @click="exportToExcel(index)"><a-icon type="download"/>{{$t("common.downloadData")}}</a-button>
                                    <a-button @click="copy(index)" id="copy-btn"><a-icon type="copy"/>{{$t("common.copyData")}}</a-button>
                                </a-button-group>
                            </h3>
                            <DataTable  :liucun="mod.liucun" :fields="mod.fields" :theads="mod.theads" 
                            :datas="mod.datas" :ref="`datatable_${index}`" :pageSize="mod.pageSize!=null?mod.pageSize:config.pageSize" :marks="marks" :color="mod.color?mod.color:config.color" :xlen="mod.xlen"  :small="true"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>  

<script>
import {ctrlMixin} from '@/utils/ctrlMixin.js'
import Searcher from '@/components/common/search/searcher.vue'
import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import PageHeader from '@/components/game/pageheader.vue'
export default {
    mixins: [ctrlMixin],
    components: {
        Searcher,
        DataTable,
        Chart,
        PageHeader,
    },
    methods: {
        // 获取页面数据
        getData(params) {
            this.loading = true
            this.$service.query(this.queryId, params).then((data)=>{
                let datas = [], infos = []

                data.forEach((d, i)=>{
                    if(i===0) {
                        datas.push(d.datas)
                        infos.push(d.infos)
                    }
                    else {
                        datas.push(d)
                    }
                })
                this.datas = datas
                this.infos = infos
                this.loading = false    
            }).catch((data)=>{
                this.loading = false
            })
        },
    },
    data() {
        return {
            datas:[[[],[]]],
            infos:[["",""]],
            current:0,
        }
    },
}
</script>
